export interface IPredictionGroup {
    message: string;
    success: boolean;
    data: any;
}

export class PredictionGroup implements IPredictionGroup {
    message: string;
    success: boolean;
    data: any;
}


// WEBPACK FOOTER //
// ./src/app/classes/PredictionGroup.ts